export default __webpack_public_path__ + "static/media/justin.b175f94f.jpeg";